import { render, staticRenderFns } from "./ProformType.vue?vue&type=template&id=66f77da0&scoped=true"
import script from "./ProformType.vue?vue&type=script&lang=js"
export * from "./ProformType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f77da0",
  null
  
)

export default component.exports